import React, { useEffect } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchPromotionCatalogList } from "../../actions/promotion";
import { useParams } from "react-router-dom";
import CatalogListItems from "../Catalog/CatalogListItems";
import { useTranslation } from "react-i18next";

const PromotionDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { promotionCatalogList } = useSelector(
    (state) => state.promotionReducer
  );

  useEffect(() => {
    dispatch(fetchPromotionCatalogList(id));
  }, [dispatch]);

  return (
    <div className="promotion-main-container">
      <Breadcrumb
        title={t("promotion.breadcrumbTitle")}
        returnPage="/promotion"
      />

      <div className="promotion-list-container">
        <CatalogListItems data={promotionCatalogList} />
      </div>
    </div>
  );
};

export default PromotionDetail;
